module.exports = __webpack_public_path__ + "img/msg_null.2272a53f.png";